/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
import { ActivatedRouteSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { Layer7ApiService } from '../http';

@Injectable()
export class FrontendResolver {

    constructor(
        private layer7ApiService: Layer7ApiService
    ) {
    }

    public resolve(route: ActivatedRouteSnapshot): any {
        return this.layer7ApiService.getFrontend(route.paramMap.get('serviceID'));
    }
}

@Injectable()
export class FrontendsResolver {

    constructor(
        private layer7ApiService: Layer7ApiService
    ) {
    }

    public resolve(): any {
        return this.layer7ApiService.getFrontends();
    }
}

@Injectable()
export class BackendsResolver {

    constructor(
        private layer7ApiService: Layer7ApiService
    ) {
    }

    public resolve(): any {
        return this.layer7ApiService.getBackends();
    }
}

@Injectable()
export class BackendsByFrontendIdResolver {

    constructor(
        private layer7ApiService: Layer7ApiService
    ) {
    }

    public resolve(route: ActivatedRouteSnapshot): any {
        return this.layer7ApiService.getBackendsByFrontendId(route.paramMap.get('serviceID'));
    }
}

@Injectable()
export class RealServersResolver {

    constructor(
        private layer7ApiService: Layer7ApiService
    ) {
    }

    public resolve(): any {
        return this.layer7ApiService.getRealServers();
    }
}

@Injectable()
export class RealServersByBackendIdResolver {

    constructor(
        private layer7ApiService: Layer7ApiService
    ) {
    }

    public resolve(route: ActivatedRouteSnapshot): any {
        return this.layer7ApiService.getRealServersByBackendId(route.paramMap.get('backendId'));
    }
}

@Injectable()
export class StickTableResolver {

    constructor(
        private layer7ApiService: Layer7ApiService
    ) {
    }

    public resolve(route: ActivatedRouteSnapshot): any {
        return this.layer7ApiService.getStickTable(route.paramMap.get('backend'), 0, 100);
    }
}

@Injectable()
export class AclsResolver {

    constructor(
        private layer7ApiService: Layer7ApiService
    ) {
    }

    public resolve(): any {
        return this.layer7ApiService.getAclRules();
    }
}

@Injectable()
export class FrontendACLsResolver {

    constructor(
        private layer7ApiService: Layer7ApiService
    ) {
    }

    public resolve(route: ActivatedRouteSnapshot): any {
        return this.layer7ApiService.getFrontendAcls(route.paramMap.get('serviceID'));
    }
}
